import React, { useMemo, useState } from "react";
import "../components/App.css";
import { Container } from "@mui/material";
import { useActiveCareUser } from "../hooks/useActiveCareUser";

const CareDetails = () => {
  const [selectedService, setSelectedService] = useState(null);
  const { userDetails } = useActiveCareUser();

  const filteredServices = useMemo(() => {
    if (!userDetails?.services || !selectedService) {
      return [];
    }

    const [selectedTypeCategory, selectedId] = selectedService.split(" - ");
    const [selectedType, selectedCategory] = selectedTypeCategory.split(" (");

    if (selectedId) {
      return userDetails.services.filter(
        (service) =>
          service.type === selectedType &&
          service.category === selectedCategory.slice(0, -1) &&
          service._id === selectedId
      );
    }

    if (selectedCategory) {
      return userDetails.services.filter(
        (service) =>
          service.type === selectedType &&
          service.category === selectedCategory.slice(0, -1)
      );
    }

    return userDetails.services.filter(
      (service) => service.type === selectedType
    );
  }, [selectedService, userDetails]);

  const serviceTypeRadioButtons = (
    <div className="service-type-radio-buttons">
      <h3>Choose a service to get the care details.</h3>
      {userDetails?.services?.map((service) => {
        const countSameTypeCategory = userDetails.services.filter(
          (item) =>
            item.type === service.type && item.category === service.category
        ).length;
        const label =
          countSameTypeCategory > 1
            ? `${service.type} (${service.category}) - ${service._id}`
            : `${service.type} (${service.category})`;

        return (
          <label key={label} className="radio-label">
            <input
              type="radio"
              value={label}
              style={{ marginRight: "5px" }}
              checked={selectedService === label}
              onChange={(event) => setSelectedService(event.target.value)}
            />
            {label}
          </label>
        );
      })}
    </div>
  );

  const serviceDetails =
    selectedService &&
    filteredServices.map((service, index) => (
      <div key={index}>
        <div className="user-container" style={{ margin: "0 auto" }}>
          <h2 style={{ textAlign: "center" }}>User Care Details</h2>
          <div className="user-details">
            {userDetails._id && (
              <div className="space-between">
                <p>
                  <strong>User Id:</strong>
                </p>
                <p>{userDetails._id}</p>
              </div>
            )}
            {service.carePurchaseDate && (
              <div className="space-between">
                <p>
                  <strong>Care Plan Activated:</strong>
                </p>
                <p>{service.carePurchaseDate}</p>
              </div>
            )}
            {service.careExpiryDate && (
              <div className="space-between">
                <p>
                  <strong>Expires on:</strong>
                </p>
                <p>{service.careExpiryDate}</p>
              </div>
            )}
            {service.brandName && (
              <div className="space-between">
                <p>
                  <strong>Brand Name:</strong>
                </p>
                <p>{service.brandName}</p>
              </div>
            )}
            {service.category && (
              <div className="space-between">
                <p>
                  <strong>Category:</strong>
                </p>
                <p>{service.category}</p>
              </div>
            )}
            {service.productCondition && (
              <div className="space-between">
                <p>
                  <strong>Product Type:</strong>
                </p>
                <p>
                  {service.productCondition}
                  {service.oldPurchaseOption && (
                    <>
                      {","} {service.oldPurchaseOption}
                    </>
                  )}
                </p>
              </div>
            )}
            {service.billValue && (
              <div className="space-between">
                <p>
                  <strong>Bill Value:</strong>
                </p>
                <p>{service.billValue}</p>
              </div>
            )}
            <div className="space-between">
              <p>
                <strong>Care Fees:</strong>
              </p>
              <p>{service.careFees}</p>
            </div>
            {service.careValueAmount && (
              <div className="space-between">
                <p>
                  <strong>Claim Amount:</strong>
                </p>
                <p>{service.careValueAmount}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    ));

  return (
    <Container>
      <div className="care-container">
          {serviceTypeRadioButtons}
          {serviceDetails}
        </div>
    </Container>
  );
};

export default CareDetails;
